import React from "react";
import { useTranslation } from "react-i18next";
import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "./ui/dropdown-menu";

const THEME_OPTIONS = [
  { value: "light", icon: Sun, key: "theme.light", fallback: "Light" },
  { value: "dark", icon: Moon, key: "theme.dark", fallback: "Dark" },
  { value: "system", icon: Monitor, key: "theme.system", fallback: "System" },
];

export default function ThemeSwitcher() {
  const { theme, resolved, setTheme } = useTheme();
  const { t } = useTranslation();
  const ActiveIcon = resolved === "dark" ? Moon : Sun;
  const labelBase = t("theme.label", { defaultValue: "Theme" });

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="theme-switcher-trigger"
        aria-label={labelBase}
        className="inline-flex items-center justify-center rounded-full border border-[#E8DEC8] dark:border-[#423B36] bg-white/70 dark:bg-[#221E1C] w-9 h-9 text-[#2C2623] dark:text-[#FAF5F0] hover:bg-[#F9F5EE] dark:hover:bg-[#2A2422] transition-colors">
        <ActiveIcon className="w-4 h-4 text-[#6E655F] dark:text-[#B5AAA1]" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" data-testid="theme-switcher-menu">
        <DropdownMenuLabel className="text-xs uppercase tracking-widest text-[#6E655F]">
          {labelBase}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {THEME_OPTIONS.map(({ value, icon: Icon, key, fallback }) => (
          <DropdownMenuItem
            key={value}
            onClick={() => setTheme(value)}
            data-testid={`theme-option-${value}`}
            className="flex items-center justify-between cursor-pointer">
            <span className="flex items-center gap-2">
              <Icon className="w-4 h-4 text-[#6E655F] dark:text-[#B5AAA1]" />
              <span>{t(key, { defaultValue: fallback })}</span>
            </span>
            {value === theme && <Check className="w-4 h-4 text-[#D95D39]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
